import { render, staticRenderFns } from "./append.vue?vue&type=template&id=d1637fac"
import script from "./append.vue?vue&type=script&lang=js"
export * from "./append.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports